import React, {useEffect} from 'react';
import { Helmet } from "react-helmet";
import { get_Token } from "../helpers/getToken";

import LoginForm from "../components/LoginForm/LoginForm";

const Ingresar = () => {

    useEffect(()=>{
        const data = () =>{
            const token = get_Token()
            if(token){
                window.location.href='/UserPanel'
            }
        }
        data()
    },[])


    return (
        <>
            <Helmet>
                <title>Rueda Digital - Ingresar</title>
            </Helmet>
            <LoginForm />
        </>

    ) 
}



export default Ingresar;